import React, { Fragment, useCallback, useEffect, useState } from "react";
import {
  Form,
  Descriptions,
  Modal,
  Button,
  message,
  Spin,
  Alert,
  InputNumber,
  Select,
  Typography,
  Tooltip,
  Grid,
} from "antd";
import styles from "../management.module.scss";
import { useAppDispatch } from "store/hook";
// import { setScheme } from "../../store/actionCreator";
import { useTranslation } from "react-i18next";
import { custInfRecordProps } from "../index";
import { useSchemeByCid, useUpdateOrCreateScheme } from "../queries";
const { useBreakpoint } = Grid;
const { Option } = Select;
const { Paragraph } = Typography;

interface schemeProps {
  SchemeModalvisible: boolean;
  setSchemeModalvisible: (arg: boolean) => void;
  record: custInfRecordProps;
  setRecord: (arg: custInfRecordProps) => void;
}

export const SchemeModalC = React.memo(
  ({ SchemeModalvisible, setSchemeModalvisible, record, setRecord }: schemeProps) => {
    const [form] = Form.useForm();
    const [SchemeData, setSchemeData] = useState<any>({});
    const [Editable, setEditable] = useState(false);
    const level = localStorage.getItem("authUser.level");
    const [IsCreate, setIsCreate] = useState(false);
    const disp = useAppDispatch();
    const { t } = useTranslation();
    const screens = useBreakpoint();

    const { data: customerScheme, isFetching: customerSchemeFetching } = useSchemeByCid(
      record?.cid,
      SchemeModalvisible
    );
    const { mutateAsync: updateOrCreateSchemeMutation, isLoading: updateOrCreateSchemeMutationLoading } =
      useUpdateOrCreateScheme(record?.cid);

    useEffect(() => {
      if (!customerScheme) {
        return;
      }
      form.setFieldsValue({
        user: customerScheme.user,
        device: customerScheme.device,
        group: customerScheme.group,
        iot: customerScheme.iot,
        iot_poor: customerScheme.iot_poor,
        tracking: customerScheme.tracking,
        tracking_pool: customerScheme.tracking_pool,
        period_alive: customerScheme.period_alive,
        period_status: customerScheme.period_status,
        period_iot: customerScheme.period_iot,
        period_gps: customerScheme.period_gps,
        alive_timeout: customerScheme.alive_timeout,
        permission_viewFlowData: customerScheme.permission_viewFlowData,
        expire: customerScheme.expire,
      });
      setSchemeData(customerScheme);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerScheme]);

    const EditSchemeOnFinish = (values: any) => {
      updateOrCreateSchemeMutation({ values, cid: record.cid, IsCreate })
        .then(() => {
          message.success(t("ISMS.Success"));
          // disp(
          //   setScheme({
          //     cid: record.cid,
          //     scheme_list: {
          //       user: values.user || 10,
          //       group: values.group || 50,
          //       device: values.device || 1000,
          //       expire: Date.parse(values.expire || "2030-12-31") / 1000,
          //       tracking: 123,
          //       tracking_pool: 123,
          //       iot: 123,
          //       iot_poor: 123,
          //       period_alive: values.period_alive,
          //       alive_timeout: values.period_alive + 30,
          //       period_status: values.period_status,
          //       period_gps: values.period_gps,
          //       period_iot: values.period_iot,
          //       permission_viewFlowData: values.permission_viewFlowData,
          //     },
          //   })
          // );
          setIsCreate(false);
          setEditable(false);
        })
        .catch(() => {
          message.error(t("ISMS.Fail"));
          setIsCreate(false);
          setEditable(false);
          form.resetFields();
        });
    };

    const AliveNumberChange = (value: number) => {
      let newValue = Math.round(value / 30) * 30;
      form.setFieldsValue({ period_alive: newValue });
    };

    const getMaxWidth = useCallback(() => {
      if (screens.xxl) return 300;
      if (screens.xl || screens.lg || screens.md) return 200;
      if (screens.sm) return 140;
      if (screens.xs) return 90;
      return 90;
    }, [screens]); // ✅ 依賴 screens，螢幕尺寸改變才重新建立
    // xxl: 4, xl: 4, lg: 3, md: 3, sm: 2, xs: 1
    const getScreens_full = useCallback(() => {
      if (screens.xxl || screens.xl) return 4;
      if (screens.lg || screens.md) return 3;
      if (screens.sm) return 2;
      if (screens.xs) return 1;
    }, [screens]); // ✅ 依賴 screens，螢幕尺寸改變才重新建立
    const getScreens_half = useCallback(() => {
      if (screens.xxl) return 2;
      if (screens.xl || screens.lg || screens.md) return 2;
      if (screens.sm) return 1;
      if (screens.xs) return 1;
    }, [screens]); // ✅ 依賴 screens，螢幕尺寸改變才重新建立

    return (
      <Modal
        visible={SchemeModalvisible}
        onCancel={() => {
          setSchemeModalvisible(false);
          setIsCreate(false);
          setRecord({ cid: undefined });
          setEditable(false);
          form.resetFields();
        }}
        centered={true}
        className={styles.modal}
        title={t("ISMS.Scheme")}
        destroyOnClose={true}
        footer={[
          level === "super_super" && Editable && (
            <Button
              key="Submit"
              loading={updateOrCreateSchemeMutationLoading}
              onClick={() => {
                form.submit();
              }}
            >
              {t("ISMS.Submit")}
            </Button>
          ),
          !Editable && (
            <Button
              key="Confirm"
              type="primary"
              loading={customerSchemeFetching}
              onClick={() => {
                setSchemeModalvisible(false);
              }}
            >
              {t("ISMS.Confirm")}
            </Button>
          ),
        ]}
      >
        {customerSchemeFetching ? (
          <Spin tip="Loading...">
            <Alert
              message="Getting Data"
              description="We are now getting data from server, please wait for a few seconds"
            />
          </Spin>
        ) : (
          SchemeData && (
            <Fragment>
              {level === "super_super" && (
                <Fragment>
                  {SchemeData.user !== "" && (
                    <Button
                      key="Edit"
                      loading={customerSchemeFetching}
                      onClick={() => {
                        setEditable(!Editable);
                      }}
                      style={{ marginRight: "5px", marginBottom: "10px" }}
                    >
                      {Editable ? t("ISMS.Cancel") : t("ISMS.Edit")}
                    </Button>
                  )}
                  {SchemeData.user === "" && (
                    <Button
                      key="Create"
                      loading={customerSchemeFetching}
                      onClick={() => {
                        setEditable(!Editable);
                        setIsCreate(true);
                      }}
                      style={{ marginRight: "5px", marginBottom: "10px" }}
                    >
                      {t("ISMS.Create")}
                    </Button>
                  )}
                </Fragment>
              )}
              <Form onFinish={EditSchemeOnFinish} form={form} layout="vertical">
                <Descriptions
                  bordered
                  className={styles.desc_scheme_first}
                  column={{ xxl: 4, xl: 3, lg: 2, md: 2, sm: 2, xs: 1 }}
                >
                  {/* <Descriptions.Item key='user' label="user">
              {Editable ? (
                  <Form.Item name={"user"}  rules={[{ required: true, message: "required" }]}>
                    <Input className={styles.SchemeInput}/>
                  </Form.Item>
                ) : (
                  `${SchemeData.users}/${SchemeData.user}`
                )}
              </Descriptions.Item>
              <Descriptions.Item key='device' label="device">
                {Editable ? (
                  <Form.Item name={"device"} rules={[{ required: true, message: "required" }]}>
                    <Input className={styles.SchemeInput}/>
                  </Form.Item>
                ) : (
                  `${SchemeData.devices}/${SchemeData.device}`
                )}
              </Descriptions.Item>
              <Descriptions.Item key='group' label="group">
                {Editable ? (
                  <Form.Item name={"group"} rules={[{ required: true, message: "required" }]}>
                    <Input className={styles.SchemeInput}/>
                  </Form.Item>
                ) : (
                  `${SchemeData.groups}/${SchemeData.group}`
                )}
              </Descriptions.Item> */}

                  <Descriptions.Item
                    key="period_alive"
                    label={t("ISMS.AlivePeriod(s)")}
                    // label={'Alive Period (s)'}
                  >
                    {Editable ? (
                      <Fragment>
                        <Form.Item
                          name={"period_alive"}
                          // initialValue={30}
                          rules={[
                            {
                              required: true,
                              message: "number is required",
                              type: "number",
                            },
                          ]}
                        >
                          <InputNumber
                            className={styles.SchemeInput}
                            min={30}
                            max={86400}
                            step={30}
                            onChange={AliveNumberChange}
                          />
                        </Form.Item>
                      </Fragment>
                    ) : (
                      SchemeData.period_alive
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item key="period_status" label={t("ISMS.StatusPeriod(s)")}>
                    {Editable ? (
                      <Form.Item name={"period_status"} rules={[{ required: true, message: "required" }]}>
                        <InputNumber className={styles.SchemeInput} min={30} max={86400} step={30} />
                      </Form.Item>
                    ) : (
                      SchemeData.period_status
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item key="period_iot" label={t("ISMS.IoTPeriod(s)")}>
                    {Editable ? (
                      <Form.Item name={"period_iot"} rules={[{ required: true, message: "required" }]}>
                        <InputNumber className={styles.SchemeInput} min={30} max={86400} step={30} />
                      </Form.Item>
                    ) : (
                      SchemeData.period_iot
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item key="period_gps" label={t("ISMS.GPSPeriod(s)")}>
                    {Editable ? (
                      <Form.Item name={"period_gps"} rules={[{ required: true, message: "required" }]}>
                        <InputNumber className={styles.SchemeInput} min={30} max={86400} step={30} />
                      </Form.Item>
                    ) : (
                      SchemeData.period_gps
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item key="alive_timeout" label={t("ISMS.AliveTimeout(s)")} style={{ display: "none" }}>
                    {Editable ? (
                      <Form.Item name={"alive_timeout"}>
                        <InputNumber className={styles.SchemeInput} />
                      </Form.Item>
                    ) : (
                      SchemeData.alive_timeout
                    )}
                  </Descriptions.Item>

                  <Descriptions.Item key="permission_viewFlowData" label={t("ISMS.View Flow Data")}>
                    {Editable ? (
                      <Form.Item name="permission_viewFlowData" rules={[{ required: true, message: "Required!!" }]}>
                        <Select placeholder={"Enable/Disable"}>
                          {/* @ts-ignore */}
                          <Option value={true}> {t("ISMS.Enable")}</Option>
                          {/* @ts-ignore */}
                          <Option value={false}> {t("ISMS.Disable")}</Option>
                        </Select>
                      </Form.Item>
                    ) : SchemeData.permission_viewFlowData ? (
                      "Enable"
                    ) : (
                      "Disable"
                    )}
                  </Descriptions.Item>

                  {/* <Form.Item
                  label={t("ISMS.View Flow Data")}
                  name="period_viewFlowData"
                  rules={[{ required: true, message: "Required!!" }]}
                  initialValue={false}
                >
                  <Select
                    placeholder={"Enable/Disable"}
                  >
                    <Option value={true}> {t("ISMS.Enable")}</Option>
                    <Option value={false}> {t("ISMS.Disable")}</Option>
                  </Select>
                </Form.Item> */}

                  {/* <Descriptions.Item key='expire' label="expire" >
                {Editable ? (
                  <Form.Item name={"expire"} rules={[{ required: true, message: "required" }]}>
                    <Input style={{width:'130px'}} placeholder='2020-12-12'/>
                  </Form.Item>
                ) : (
                  SchemeData.expire
                )}
              </Descriptions.Item> */}
                </Descriptions>
                <Descriptions
                  bordered
                  className={styles.desc_scheme_second}
                  column={{ xxl: 4, xl: 4, lg: 3, md: 3, sm: 2, xs: 1 }}
                >
                  {(record?.cid as string) && (
                    <Descriptions.Item
                      key="cid"
                      label={"CID"}
                      className={styles.ParagraphCid_Des}
                      span={getScreens_full()}
                    >
                      <Paragraph
                        copyable={{ text: record?.cid, tooltips: "Copy cid" }}
                        style={{ display: "flex", gap: "8px" }}
                      >
                        <Tooltip
                          title={record?.cid} // hover 顯示完整內容
                        >
                          {/* { xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 } */}
                          <span
                            style={{
                              display: "inline-block",
                              maxWidth: screens.xs ? "90px" : "unset",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              verticalAlign: "bottom",
                            }}
                          >
                            {record?.cid}
                          </span>
                        </Tooltip>
                      </Paragraph>
                      {/* {SchemeData?.node_red_inf?.pwd} */}
                    </Descriptions.Item>
                  )}
                  {SchemeData?.openapi_token && (
                    <Descriptions.Item
                      key="openapi_token"
                      label={"OpenAPI Token"}
                      className={styles.nodeRED_Des}
                      span={getScreens_full()}
                    >
                      <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                        <Paragraph
                          copyable={{ text: SchemeData?.openapi_token, tooltips: "Copy OpenAPI Token" }}
                          style={{ display: "flex", gap: "8px" }}
                        >
                          <Tooltip
                            title={SchemeData?.openapi_token} // hover 顯示完整內容
                          >
                            {/* { xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 } */}
                            <span
                              style={{
                                display: "inline-block",
                                maxWidth: getMaxWidth(),
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                verticalAlign: "bottom",
                              }}
                            >
                              {SchemeData?.openapi_token}
                            </span>
                          </Tooltip>
                          {/* 更新 Token 按鈕 */}
                        </Paragraph>
                      </div>
                    </Descriptions.Item>
                  )}
                </Descriptions>
              </Form>
            </Fragment>
          )
        )}
      </Modal>
    );
  }
);
